import { render } from "./LoginLoader.vue?vue&type=template&id=37544eb2"
import script from "./LoginLoader.vue?vue&type=script&lang=js"
export * from "./LoginLoader.vue?vue&type=script&lang=js"

import "./LoginLoader.vue?vue&type=style&index=0&id=37544eb2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__